import { render, staticRenderFns } from "./SingleSection.vue?vue&type=template&id=2fdaa9ea&scoped=true"
import script from "./SingleSection.vue?vue&type=script&lang=js"
export * from "./SingleSection.vue?vue&type=script&lang=js"
import style0 from "./SingleSection.vue?vue&type=style&index=0&id=2fdaa9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdaa9ea",
  null
  
)

export default component.exports